import { render } from "./cepingchaxun.vue?vue&type=template&id=3522ed4d&scoped=true"
import script from "./cepingchaxun.vue?vue&type=script&lang=js"
export * from "./cepingchaxun.vue?vue&type=script&lang=js"

import "./cepingchaxun.vue?vue&type=style&index=0&id=3522ed4d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3522ed4d"

export default script